import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from '@angular/core';
import { ModalController } from '@ionic/angular';

import { Sale } from '../../../../models/sale/sale.model';
import { Payment } from '../../../../models/payment/payment.model';
import { Tip } from '../../../../models/tip/tip.model';
import {
  SaleService,
  SALE_CHECKOUT_TYPE,
} from '../../../../services/sale.service';
import { SalePaymentFormPage } from '../../../sale-checkout/sale-payment-form/sale-payment-form.page';
import { SaleTipFormPage } from '../../../sale-checkout/sale-tip-form/sale-tip-form.page';
import { Router } from '@angular/router';
import { SalonMonsterCurrencyPipe } from '../../../../pipes/salonmonster-currency.pipe';
import { NavigationStateService } from '../../../../services/navigation-state.service';
@Component({
  selector: 'smr-tips-payments-manager',
  templateUrl: './tips-payments-manager.component.html',
  styleUrls: ['./tips-payments-manager.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SalonMonsterCurrencyPipe],
  styles: [
    `
      .pos-header {
        margin-bottom: 0;
        padding-bottom: 0;
      }
      .pos-header .item-inner {
        height: 30px;
      }
      .sm-payment-button .label-md {
      }
    `,
  ],
})
export class TipsPaymentsManagerComponent implements OnChanges {
  @Input() sale: Sale;

  @Input() showButtons: boolean;

  @Output() saleUpdated = new EventEmitter<Sale>();

  @Input() isFromBookings: boolean;

  @Input() isFromRegisterClosure;

  cashTip: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    //private navCtrl: NavController,
    private saleService: SaleService,
    private changeDetectorRef: ChangeDetectorRef,
    private salonMonsterCurrency: SalonMonsterCurrencyPipe,
    private router: Router,
    private navigationStateService: NavigationStateService
  ) {}

  public ngOnChanges() {
    if(this.sale.balance < 0 && this.sale.payments.count() == 1 && this.sale.payments.first().type == 1)
      this.cashTip = true

  }

  public onSaleUpdated($event: Sale) {
    this.sale = $event;
    this.saleUpdated.emit(this.sale);
  }

  public async editTip(tip: Tip, index: number) {
    const modal = await this.modalCtrl.create({
      component: SaleTipFormPage,
      componentProps: { sale: this.sale, tip: tip, showRemoveButton: true },
      cssClass: 'modal-bg',
    });
    modal.onWillDismiss().then((data: any) => {
      if (data.data) {
        if (data.data.action === 'save') {
          this.sale = this.sale.updateTip(index, data.data.tip);
          // this.completeSale();
        } else {
          this.sale = this.sale.removeTip(index);
        }

        this.saleUpdated.emit(this.sale);
        this.changeDetectorRef.markForCheck();
      }
    });
    return await modal.present();
  }

  public async editPayment(payment: Payment, index: number) {
    const modal = await this.modalCtrl.create({
      component: SalePaymentFormPage,
      componentProps: {
        sale: this.sale,
        payment: payment,
        paymentIndex: index,
        showRemoveButton: true,
      },
      cssClass: 'modal-bg',
    });
    modal.onWillDismiss().then((data: any) => {
      if (data) {
        if (data.action === 'save') {
          this.sale = this.sale.updatePayment(index, data.payment);
          // this.sale = this.sale.setCashRounding(data.cashRounding);
          this.saleUpdated.emit(this.sale);
          this.completeSale();
        } else {
          this.sale = this.sale.removePayment(index);
          this.saleUpdated.emit(this.sale);
        }

        this.changeDetectorRef.markForCheck();
      }
    });
    await modal.present();
  }

  public completeSale() {
    this.saleService.setSaleToBeCheckedOut(
      this.sale,
      SALE_CHECKOUT_TYPE.salonMonsterPay
    );
      this.navigationStateService.setState({
        sale: this.sale,
          isFromBookings: this.isFromBookings,
          isFromRegisterClosure: this.isFromRegisterClosure
      });
    if (this.sale.isSaleReadyForCheckOut()) {
        this.router.navigate(
          ['./sales/sale-checkout/sale-confirmation']
        );
    }
  }
}
